import * as Scrivito from "scrivito"

export const FooterObjClass = Scrivito.provideObjClass("Footer", {
  attributes: {
    contactDetailsWidget: ["widgetlist", { only: "ContactDetailsWidget" }],
    socialsWidget: ["widgetlist", { only: "SocialsWidget" }],
    topLinks: ["widgetlist", { only: "LinkListWidget" }],
    bottomLinks: ["widgetlist", { only: "LinkListWidget" }]
  }
})
